export namespace FileConstants {
  export const fileSizeLimit = 3097152;
  export const fileSizeErrorMsg = 'File Size should be less than 3MB';

  export enum FileSection {
    Profile = 1,
    Topic = 2,
    SubTopic = 3
  }
}
